import * as React from 'react';
import b_ from 'b_';
import './styles.scss';

const b = b_.with('animate-overlay');

interface IProps {
  isVisible?: boolean;
}

export const AnimateOverlay: React.FC<IProps> = ({ isVisible, children }) => {
  return <div className={b({ visible: isVisible })}>{children}</div>;
};
